export default __webpack_public_path__ + "static/media/add.ed821fe7.svg";